module.exports = __webpack_public_path__ + "static/media/life_stealer.5eadf3b0.png";